import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ApprovalsComponent } from './approvals.component';
import { RouterModule, Routes } from '@angular/router';
import { TaskApprovalPageComponent } from './task-approval-page/task-approval-page.component';

import { ApprovalsResolver } from './approvals.resolver';

const routes: Routes = [
  {
    path: ':id',
    component: ApprovalsComponent,
    resolve: { approval: ApprovalsResolver },
    children: [
      {
        path: 'task',
        component: TaskApprovalPageComponent,
      },
    ],
  },
];

@NgModule({
  imports: [CommonModule, RouterModule.forChild(routes)],
  declarations: [ApprovalsComponent],
})
export class ApprovalsModule {}
